export default {
  Switch: {
    parts: ['container', 'track', 'thumb'],
    baseStyle: {
      track: {
        _focus: {
          boxShadow: 'none',
        },
      },
    },
    sizes: {},
    variants: {
      primary: {
        track: {
          padding: '0',
          _checked: {
            bgColor: 'primary.base',
          },
        },
        thumb: {
          border: 'medium',
          borderColor: 'primary.base',
        },
      },
    },
    defaultProps: {
      variant: 'primary',
    },
  },
};
